import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { ErrorMessage } from '../ErrorMessage'

import './styles.scss'

export class Toggle extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange () {
    const { onChange, value } = this.props
    if (onChange) {
      onChange(!value)
    }
  }

  render () {
    const { label, value, errors, colorScheme } = this.props

    const labelStyles = {
      cursor: 'pointer',
      letterSpacing: '0.3px',
      color: value ? '#8400FF' : '#867e92',
      fontSize: '12px',
      textTransform: 'uppercase',
      fontWeight: 500,
      userSelect: 'none'
    }

    return (
      <div className='switch-container'>
        <label className='checkbox-container'>
          <input
            type='checkbox'
            checked={value}
            onChange={this.handleChange}
          />
          <span
            className={cx('checkbox-switch', colorScheme)}
          />
        </label>
        { }
        <span
          className='switch-label'
          style={labelStyles}
          onClick={this.handleChange}
        >
          {label}
        </span>
        <ErrorMessage errors={errors} />
      </div>
    )
  }
}

Toggle.defaultProps = {
  value: false
}

Toggle.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string)
}
